<mat-card appearance="outlined" *ngIf="!submitSuccess">
    <mat-card-content>
  
      <div class="d-flex justify-content-center" *ngIf="submitting">
        <mat-spinner></mat-spinner>
      </div>
  
      <div *ngIf="!submitting && !submitSuccess" >
        <form [formGroup]="changeForm">
            <mat-form-field>
              <mat-label>Current Password</mat-label>
              <input matInput formControlName="currentPassword" [type]="passwordVisibility.currentPassword ? 'text' : 'password'" autocomplete="current-password" />
              <button matSuffix mat-icon-button aria-label="Show Password" (click)="togglePasswordVisibility('currentPassword')">
                <mat-icon>{{ passwordVisibility.currentPassword ? 'visibility' : 'visibility_off'  }}</mat-icon>
              </button>
              <mat-error *ngIf="changeForm.controls.password.errors?.['required']">Current Password is required</mat-error>
            </mat-form-field>

          <mat-form-field>
            <mat-label>New Password</mat-label>
            <input matInput formControlName="password" [type]="passwordVisibility.password ? 'text' : 'password'" autocomplete="new-password" />
            <button matSuffix mat-icon-button aria-label="Show Password" (click)="togglePasswordVisibility('password')">
              <mat-icon>{{ passwordVisibility.password ? 'visibility' : 'visibility_off'  }}</mat-icon>
            </button>
            <mat-error *ngIf="changeForm.controls.password.errors?.['required']">New Password is required</mat-error>
            <mat-error *ngIf="changeForm.controls.password.errors?.['pattern']"></mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirmPassword" [type]="passwordVisibility.confirmPassword ? 'text' : 'password'" autocomplete="new-password" />
            <button matSuffix mat-icon-button aria-label="Show Password" (click)="togglePasswordVisibility('confirmPassword')">
              <mat-icon>{{ passwordVisibility.confirmPassword ? 'visibility' : 'visibility_off'  }}</mat-icon>
            </button>
            <mat-error *ngIf="changeForm.controls.confirmPassword.errors?.['required']">Confirm Password is required</mat-error>
          </mat-form-field>
 
          <div class="d-flex form-item m-t-1">
            <button class="flex-1" mat-flat-button (click)="change()" [disabled]="changeForm.invalid">Change Password</button>
          </div>
        </form>

        <div class="mat-error" *ngIf="changeForm.controls.password.errors?.['pattern']">
            <div class="mat-error">
            <div>Password does not meet the requirements</div>
            <div>The password must contain:</div>
            <div>1 number</div>
            <div>1 lowercase letter</div>
            <div>1 capital letter</div>
            <div>8 - 50 characters</div>
            </div>
        </div>

       <div *ngIf="errorOnSubmit">
          <div *ngIf="errorCodes.length > 0 && errorCodesToShow.length == 0">
            <div class="mat-error">
            <div>Password does not meet the requirements</div>
            <div>The password must contain:</div>
            <div>1 number</div>
            <div>1 lowercase letter</div>
            <div>1 capital letter</div>
            <div>8 - 50 characters</div>
            </div>
          </div>
            <div *ngIf="errorCodesToShow.length > 0">
            <div *ngFor="let errorCode of errorCodesToShow" class="mat-error">{{ 'change-password.error.' + errorCode | translate}}</div>
            </div>
          
          <div *ngIf="errorCodes.length === 0" class="mat-error">
            An error occured while changing your password, please try again later
          </div>
        </div>
      </div>

       

    </mat-card-content>
  </mat-card>
  